import React, { Component } from "react";

import "./Header.css";
import "./Namecard.css";
import ChartData from "./ChartData";
import SoundGraphic from "./SoundGraphic";

export default class Header extends Component {
  render() {
    return (
      <div className="Header">
        {/* <h3>Tomayto, Tomahto</h3>
        <h4>Description here...</h4> */}
        <ChartData />
        {/* <SoundGraphic /> */}
      </div>
    );
  }
}
